// Shared string constants for quote/negotiation status fields (bid_status, main_status) and the
// LoRRI agent's per-transporter enquiry_stage, used across Summary.js, Timeline.js, and the
// negotiation-agent status UI. Centralized so a typo in one of these strings is a compile-time
// reference error instead of a silently-mismatched comparison.

export const BID_STATUS = {
  PENDING: "pending",
  NEGOTIATED: "negotiated",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
  APPROVED: "approved",
  APPROVAL_PENDING: "approval_pending",
};

export const ENQUIRY_STAGE = {
  NEW_ENQUIRY: "new_enquiry",
  NEGOTIATION_IN_PROGRESS: "negotiation_in_progress",
  READY_FOR_HANDOFF: "ready_for_handoff",
  ACCEPTED: "accepted",
  APPROVED: "approved",
};
